import React from 'react'

import { ZariContext } from '_zari/context'
import { Button, Col, Form, Portlet, Row, Table } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'
import { EstadosBajaActivoConstant, MotivosBajaActivoConstant } from 'constants/index'

import * as ActivosFijosBajasService from 'services/activosFijosBajas.service'

const portletBreadcrumbs = [{ name: 'Activos Fijos' }, { name: 'Bajas' }, { name: 'Editar' }]

const EditarPage = ({ history, match }) => {
  const __zariContext = React.useContext(ZariContext)
  const idBaja = match.params.idBaja
  const [data, setData] = React.useState(null)
  const [comentarioEstado, setComentarioEstado] = React.useState('')

  const cargar = React.useCallback(() => {
    ActivosFijosBajasService.get(idBaja).then(({ data }) => setData(data))
  }, [idBaja])

  React.useEffect(() => {
    cargar()
  }, [cargar])

  const cambiarEstado = React.useCallback(
    async nuevoEstado => {
      try {
        await ActivosFijosBajasService.cambiarEstado(idBaja, { nuevoEstado, comentario: comentarioEstado })
        __zariContext.snack('success', 'Estado actualizado')
        setComentarioEstado('')
        cargar()
      } catch (e) {
        __zariContext.snack('error', e?.data?.error || 'Error al cambiar estado')
      }
    },
    [idBaja, comentarioEstado, __zariContext, cargar]
  )

  if (!data) return null
  if (data.error) return <div>{data.error}</div>

  const estadoInfo = EstadosBajaActivoConstant.__dictionary[data.estado]

  const transicionesBotones = {
    [EstadosBajaActivoConstant.BORRADOR]: [
      { label: 'Enviar a Revisión', to: EstadosBajaActivoConstant.EN_REVISION, color: 'primary' },
      { label: 'Anular', to: EstadosBajaActivoConstant.ANULADO, color: 'danger' }
    ],
    [EstadosBajaActivoConstant.EN_REVISION]: [
      { label: 'Aprobar', to: EstadosBajaActivoConstant.APROBADO, color: 'success' },
      { label: 'Rechazar', to: EstadosBajaActivoConstant.RECHAZADO, color: 'danger' },
      { label: 'Anular', to: EstadosBajaActivoConstant.ANULADO, color: 'secondary' }
    ],
    [EstadosBajaActivoConstant.APROBADO]: [
      { label: 'Dar de Baja', to: EstadosBajaActivoConstant.DADO_DE_BAJA, color: 'primary' },
      { label: 'Anular', to: EstadosBajaActivoConstant.ANULADO, color: 'danger' }
    ],
    [EstadosBajaActivoConstant.RECHAZADO]: [
      { label: 'Regresar a Borrador', to: EstadosBajaActivoConstant.BORRADOR, color: 'primary' }
    ]
  }

  const botones = transicionesBotones[data.estado] || []

  return (
    <Portlet>
      <Portlet.Header
        title={`Baja ${data.codigo} - ${estadoInfo?.nombre || ''}`}
        breadcrumbs={portletBreadcrumbs}
        buttons={[
          { name: 'Volver', onClick: () => history.push(`/${CodigosTransaccionesConstant.ACTIVOSFIJOS_BAJAS_LISTA}`) }
        ]}
      />
      <Portlet.Body>
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='ACTIVO FIJO' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.codigoActivoFijo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='DESCRIPCIÓN ACTIVO' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.descripcionActivoFijo} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='MOTIVO' md={12} />
              <Col md={12}>
                <Form.InputText
                  disabled
                  defaultValue={MotivosBajaActivoConstant.__dictionary[data.motivo]?.nombre || data.motivo || '--'}
                />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='FECHA SOLICITUD' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.fechaSolicitud} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='FECHA APROBACIÓN' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.fechaAprobacion || '--'} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='FECHA BAJA' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.fechaBaja || '--'} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group>
              <Form.Label text='SOLICITANTE' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.solicitanteNombre} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='DESCRIPCIÓN' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.descripcion} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='OBSERVACIONES' md={12} />
              <Col md={12}>
                <Form.InputText disabled defaultValue={data.observaciones} />
              </Col>
            </Form.Group>
          </Col>
        </Row>

        {botones.length > 0 && (
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label text='COMENTARIO (opcional)' md={12} />
                <Col md={12}>
                  <Form.InputText value={comentarioEstado} onChange={e => setComentarioEstado(e.target.value)} />
                </Col>
              </Form.Group>
            </Col>
            <Col md={12} style={{ textAlign: 'right' }}>
              {botones.map(b => (
                <Button key={b.to} color={b.color} onClick={() => cambiarEstado(b.to)} style={{ marginLeft: '8px' }}>
                  {b.label}
                </Button>
              ))}
            </Col>
          </Row>
        )}

        <Row>
          <Col md={12}>
            <h5>Trazabilidad</h5>
            <Table
              useNest={true}
              headRows={[
                { label: 'FECHA' },
                { label: 'ESTADO ANTERIOR' },
                { label: 'ESTADO NUEVO' },
                { label: 'USUARIO' },
                { label: 'COMENTARIO' }
              ]}
              filas={data.trazabilidad || []}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{row.fecha || '--'}</Table.Cell>
                  <Table.Cell>{EstadosBajaActivoConstant.__dictionary[row.estadoAnterior]?.nombre || '--'}</Table.Cell>
                  <Table.Cell>{EstadosBajaActivoConstant.__dictionary[row.estadoNuevo]?.nombre || '--'}</Table.Cell>
                  <Table.Cell>{row.usuarioNombre || '--'}</Table.Cell>
                  <Table.Cell>{row.comentario || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
        </Row>
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(EditarPage)
